import { render, staticRenderFns } from "./FundTypeList.vue?vue&type=template&id=3f054b38&"
import script from "./FundTypeList.vue?vue&type=script&lang=js&"
export * from "./FundTypeList.vue?vue&type=script&lang=js&"
import style0 from "./FundTypeList.vue?vue&type=style&index=0&id=3f054b38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports